

import React,{useEffect,useRef,useState} from 'react'
import gsap,{Back} from 'gsap'
import classNames from 'classnames'
import styles from '../styles/switch.module.css'


const Switch =props=>{

    const ref =  useRef()
    const [selected,setSelected] = useState(props.selected?props.selected:false)
    
    function onChangeSwitch(){
       if(props.onChange) props.onChange(!selected)
       setSelected(!selected)
    }

    return (<section className={`${styles.sectionContainer} `} ref={ref} >
            <input type="checkbox" checked={selected}  className={styles.switchCheckbox1} onChange={(evt)=>{console.log(evt)}} />
            <label className={classNames(styles.switchLbl, props.disabled && styles.disabled)} onClick={props.disabled ? undefined : onChangeSwitch}></label>
    </section>)

}

export default Switch